import React from 'react'
import { Link } from 'react-router-dom'
import { PrimaryButton } from '@infotech/uikit-button'
import { AddIcon } from '@infotech/uikit-icons'
import { REACT_APP_LOGO_TOP_BAR_NAME, CORE_URL, REACT_APP_WITH_CUSTOM_LOGO } from 'api/constants'
import LogoIMGComponent from 'components/LogoIMG'

const cheackConditionWithEnv = (env) => env && env !== `undefined`

const CreateButton = () => <Link to="/issue/create">
  <span>
    <PrimaryButton icon={AddIcon}>Новая заявка</PrimaryButton>
  </span>
</Link>

const getHeaderConfig = () => {
  const headerConfig = {
    HeaderActionButton: CreateButton,
  }
  const imageUrl = `${CORE_URL.replace(`/api`, ``)}/static/logo/logo.png`
  if (cheackConditionWithEnv(REACT_APP_WITH_CUSTOM_LOGO)) {
    headerConfig.withInfotechLogo = false
    headerConfig.Logo = () => <LogoIMGComponent src={imageUrl} />
  } else {
    headerConfig.withInfotechLogo = true
  }
  if (cheackConditionWithEnv(REACT_APP_LOGO_TOP_BAR_NAME)) {
    headerConfig.topBarName = REACT_APP_LOGO_TOP_BAR_NAME
  }
  if (cheackConditionWithEnv(REACT_APP_WITH_CUSTOM_LOGO) && !cheackConditionWithEnv(REACT_APP_LOGO_TOP_BAR_NAME)) {
    headerConfig.topBarName = null
  }
  return headerConfig
}

export default getHeaderConfig
